import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  effect,
  Input,
  OnInit,
} from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { PatientSessionService } from '../patient-session.service';
import {
  PatientTargetDataModel,
  PatientTargetModel,
  PatientTargetStatus,
} from '../../../core/api/models';
import { BaseBoxComponent } from '../base-box/base-box.component';
import { AlertService } from '../../../shared/services/alert.service';
@Component({
  selector: 'app-box-quantity',
  templateUrl: './box-quantity.component.html',
  styleUrls: ['../data-entry-feedback.css'],
  standalone: false,
})
export class BoxQuantityComponent extends BaseBoxComponent {
  text: string | undefined = '-';
  quantity: number | null = null;
  @Input() isTopBox: boolean = true;
  @Input() isBottomBox: boolean = false;
  @Input() target: PatientTargetModel | undefined = undefined;
  @Input() isPreview?: boolean;
  expectedAmount: number = 0;
  unit: string = '';

  targetID: number = 0;
  targetData: PatientTargetDataModel[] = [];
  quantities: {
    Quantity: number;
    RecordedDate: string;
    FormattedDate: string;
  }[] = [];
  remainingTrials: number = 0;
  addingTargetData: boolean = false;
  justRecorded: boolean = false;

  constructor(
    protected override cdRef: ChangeDetectorRef,
    private patientSessionService: PatientSessionService,
    private alertService: AlertService
  ) {
    super(cdRef);
    effect(() => {
      this.patientSessionService.dataChanged();
      const targetData = this.patientSessionService.getTargetData(
        this.targetID
      );
      if (targetData) {
        this.targetData = targetData.filter((t) => !t.DeletedDate);

        this.remainingTrials =
          (this.target?.DesiredTrials ?? 0) - this.targetData.length;
        if (this.remainingTrials < 0) {
          this.remainingTrials = 0;
        }

        if (
          this.target?.TargetStatus === PatientTargetStatus.Mastered ||
          this.target?.TargetStatus === PatientTargetStatus.Closed ||
          this.target?.TargetStatus === PatientTargetStatus.Fluent
        ) {
          this.remainingTrials = 0;
        }
        this.quantities = this.targetData.map((t) => ({
          Quantity: t.IntValue ?? 0,
          RecordedDate: t.RecordedDate ?? '',
          FormattedDate: this.formatDate(new Date(t.RecordedDate ?? '')),
        }));
      } else {
        this.quantities = [];
        this.targetData = [];
      }
    });
  }

  ngOnInit(): void {
    this.targetID = this.target?.ID ?? 0;
    this.unit = this.target?.QuantityUnit ?? 'units';
    this.expectedAmount = this.target?.DesiredTrials ?? 1;
    this.text = this.target?.TargetName ?? '-';
  }

  override doLongPress(): void {
    this.showExtra();
  }

  hitQuantity(event: KeyboardEvent) {
    if (
      event.key === 'Enter' &&
      this.quantity !== null &&
      this.quantity !== undefined
    ) {
      this.addQuantity();
    }
  }

  addQuantity() {
    if (
      this.quantity === null ||
      this.quantity === undefined ||
      this.quantity < 0 ||
      isNaN(this.quantity)
    ) {
      return;
    }

    if (this.addingTargetData) {
      return;
    }
    this.addingTargetData = true;
    //if last recorded date is on the same second as the current date, don't show the extra
    if (
      this.targetData.length > 0 &&
      this.targetData[this.targetData.length - 1].RecordedDate
    ) {
      const lastRecordedDate =
        this.targetData[this.targetData.length - 1].RecordedDate?.slice(
          0,
          19
        ) ?? '';
      const currentDate = new Date()
        .toISOString()
        .slice(0, 19)
        .replace('T', ' ');
      const currentDateToUse = new Date(currentDate)
        .fromUTCtoServerString()
        .slice(0, 19);
      //remove milliseconds
      if (lastRecordedDate === currentDateToUse) {
        this.addingTargetData = false;
        return;
      }
    }

    this.patientSessionService.addTargetData({
      PatientTargetID: this.targetID,
      IntValue: this.quantity,
      TextValue: '',
      RecordedDate: new Date().toServerString(),
    });
    this.quantity = null;
    this.justRecorded = true;
    setTimeout(() => {
      this.justRecorded = false;
    }, 220);
    setTimeout(() => {
      this.addingTargetData = false;
    }, 1000);
  }

  deleteData(data: any) {
    //confirm the deletion
    const confirmed = this.alertService.confirm(
      'Are you sure you want to delete this data?',
      'Delete Data'
    );
    confirmed.subscribe((result) => {
      if (result) {
        let targetDataToSave: PatientTargetDataModel | undefined =
          this.targetData.find((t) => t.RecordedDate === data.RecordedDate);

        if (targetDataToSave) {
          targetDataToSave.DeletedDate = new Date().toServerString();
          this.patientSessionService.saveTargetData(targetDataToSave);
        }
      }
    });
  }
}
